import { useMemo } from 'react';
import useRangeFilter from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/hooks/useRangeFilter';
import { createRangeSchema } from '@/creditflowresearch/ui/common/hooks/sidebar/rangeSchema';
import {
  useCorporateBondScreenerSidebarFilterContext,
} from '@/creditflowresearch/application/CorporateBondScreener/Sidebar/useCorporateBondScreenerSidebarFilterContext';

const useXCovered = () => {
  const { filters } = useCorporateBondScreenerSidebarFilterContext();
  const schema = useMemo(() => createRangeSchema({ bounds: filters?.xCovered }), [filters?.xCovered]);

  return useRangeFilter({ fromKey: 'includedXCoveredFrom', toKey: 'includedXCoveredTo', schema });
};

export default useXCovered;
